import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { v4 as uuid } from 'uuid';

import { InlineNoteEditorType } from './inline-note-editor-type';
import {
  CancelInlineNoteEditorEvent,
  ConfirmInlineNoteEditorEvent,
  DeleteInlineNoteEditorEvent,
} from './inline-note-editor.events';

export const NOTE_MAX_LENGTH = 2000;

@Component({
  selector: 'rl-inline-note-editor',
  templateUrl: './inline-note-editor.component.html',
})
export class InlineNoteEditorComponent implements OnChanges {
  @Input() noteType: InlineNoteEditorType;
  @Input() note: string | null;

  @Output() cancel = new EventEmitter<CancelInlineNoteEditorEvent>();
  @Output() save = new EventEmitter<ConfirmInlineNoteEditorEvent>();
  @Output() delete = new EventEmitter<DeleteInlineNoteEditorEvent>();

  InlineNoteEditorType = InlineNoteEditorType;
  inlineNoteEditorForm: FormGroup;

  private uuid: string;

  constructor(private formBuilder: FormBuilder) {
    this.createForm();
    this.uuid = uuid();
  }

  get errorMessageId(): string {
    return `${this.uuid}__errors`;
  }

  get noteEditorId(): string {
    return `${this.uuid}__textarea`;
  }

  get noteControl(): AbstractControl {
    return this.inlineNoteEditorForm.get('note');
  }

  createForm() {
    this.inlineNoteEditorForm = this.formBuilder.group({
      note: this.formBuilder.control(this.note, [
        Validators.required,
        Validators.pattern(/\S/),
        Validators.maxLength(NOTE_MAX_LENGTH),
      ]),
    });
  }

  ngOnChanges(changes?: SimpleChanges) {
    if (changes['note']) {
      this.rebuildForm();
    }
  }

  rebuildForm() {
    this.inlineNoteEditorForm.reset({
      note: this.note,
    });
  }

  get noteMaxLength() {
    return NOTE_MAX_LENGTH;
  }

  onSubmit() {
    if (this.inlineNoteEditorForm.invalid) {
      return;
    }

    const formModel = this.inlineNoteEditorForm.value;

    this.save.emit({
      noteType: this.noteType,
      note: formModel.note.trim(),
    });
  }

  onCancel() {
    this.cancel.emit({
      noteType: this.noteType,
    });
  }

  onDelete() {
    this.delete.emit({
      noteType: this.noteType,
    });
  }
}
